import api from "./index";
import { ENDPOINTS } from "./endpoints";

/* CREATE */
export const createMainCategory = (data) => {
  return api.post(ENDPOINTS.MAIN_CATEGORIES.CREATE, data);
};

/* SEARCH + LIST */
export const listMainCategoryByParams = (data) => {
  return api.post(ENDPOINTS.MAIN_CATEGORIES.SEARCH, data);
};

/* GET BY ID */
export const getMainCategoryById = (id) => {
  return api.get(ENDPOINTS.MAIN_CATEGORIES.BY_ID(id));
};

/* UPDATE */
export const updateMainCategory = (id, data) => {
  return api.put(ENDPOINTS.MAIN_CATEGORIES.UPDATE(id), data);
};

/* DELETE */
export const deleteMainCategory = (id) => {
  return api.delete(ENDPOINTS.MAIN_CATEGORIES.DELETE(id));
};

/* INDUSTRY GROUP DROPDOWN */
export const industryGroupDropdown = () => {
  return api.get(ENDPOINTS.MAIN_CATEGORIES.INDUSTRY_GROUP_DROPDOWN);
};